import React, { Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import {
    Paper, Grid, Typography, ButtonGroup,
    Button, Divider, TextField,
    Select, MenuItem,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Icon from '@mdi/react';
import {
    mdiEyeOff, mdiEye, mdiDomainPlus,
    mdiShapePolygonPlus, mdiPinOff, mdiBackspaceOutline
} from '@mdi/js';
import {
    searchZones, searchMarkers, unpinAllMarkers, unpinAllZones,
    pinnedMarkersListSelector, pinnedZonesListSelector, selectedtagSelector, setSelectedTag,
} from '../../features/places/placesSlice';

import { setNeedBounding } from '../../features/map/mapSlice';
import { tagList } from '../../utils/placeTagsOptions';



const PlacesTop = ({ setListViewCallback, listView }) => {

    const dispatch = useDispatch();
    const pinnedMarkers = useSelector(pinnedMarkersListSelector);
    const pinnedZones = useSelector(pinnedZonesListSelector);
    const selectedTag = useSelector(selectedtagSelector);

    const onZoneFilter = (e) => {
        dispatch(searchZones(e.target.value));
        if (e.target.value !== "") {
            dispatch(setNeedBounding(true));
        }
    }

    const onTagChange = (e, nv) => {
        console.log("tag selected", e.target.value, nv);
        dispatch(setSelectedTag(nv));
    }

    const onMarkerFilter = (e) => {
        dispatch(searchMarkers(e.target.value));
        if (e.target.value !== "") {
            dispatch(setNeedBounding(true));
        }
    }

    const setListView = (type) => {
        setListViewCallback(type);
    }

    const zoneView = () => {

        return (
            <Grid container spacing={1} style={{ width: '95%' }}>
                {
                    listView.search("Create") === -1 &&
                    <Fragment>
                            <Grid item sm={7}>
                                <div style={{ marginLeft: '10px' }}>
                                    <TextField
                                        variant="standard"
                                        id="zone Search"
                                        label="Search Name"
                                        onChange={onZoneFilter}
                                    />

                                </div>
                            </Grid>
                            <Grid item sm={5}>
                                <div style={{ marginLeft: '10px' }}>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        options={tagList}
                                        sx={{ width: '100%' }}
                                        onChange={onTagChange}
                                        value={selectedTag ? selectedTag : null}
                                        renderInput={(params) => <TextField {...params} label="Tags" variant="standard" />}
                                    />
                                </div>
                            </Grid>
                        <Grid item sm={12}>
                            <ButtonGroup variant="outlined" size="small">
                                <Button
                                    onClick={() => setListView('zoneCreate')}
                                    startIcon={
                                        <Icon path={mdiShapePolygonPlus}
                                            title="Create Zone"
                                            size={0.8}
                                            color="SlateBlue"
                                        />
                                    }
                                >
                                    Create Zone
                                </Button>
                                <Button
                                    onClick={() => setListView(listView === 'noList' ? 'zoneList' : 'noList')}
                                    startIcon={
                                        listView === 'noList' ?
                                            <Icon path={mdiEye}
                                                title="Show List"
                                                size={0.8}
                                                color="DodgerBlue"
                                            />
                                            :
                                            <Icon path={mdiEyeOff}
                                                title="Hide List"
                                                size={0.8}
                                                color="Crimson"
                                            />
                                    }
                                >
                                    {listView === 'noList' ? 'Show' : 'Hide'} List
                                </Button>
                                {
                                    pinnedZones.length > 0 &&
                                    <Button
                                        onClick={() => dispatch(unpinAllZones())}
                                        endIcon={
                                            <Icon path={mdiPinOff}
                                                title="Unpin"
                                                size={0.8}
                                                color="Indigo"
                                            />
                                        }
                                    >
                                        Unpin All
                                    </Button>
                                }
                            </ButtonGroup>
                        </Grid>
                    </Fragment>
                }

            </Grid>
        )
    }

    const markerView = () => {
        return (
            <Grid container spacing={1} style={{ width: '95%' }}>
                {
                    listView.search("Create") === -1 &&
                    <Fragment>
                            <Grid item sm={7}>
                            <div style={{ marginLeft: '10px' }}>
                                <TextField
                                    variant="standard"
                                    id="zone Search"
                                        label="Search Name"
                                    onChange={onMarkerFilter}
                                />
                            </div>
                            </Grid>
                            <Grid item sm={5}>
                                <div style={{ marginLeft: '10px' }}>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        options={tagList}
                                        sx={{ width: '100%' }}
                                        onChange={onTagChange}
                                        value={selectedTag ? selectedTag : null}
                                        renderInput={(params) => <TextField {...params} label="Tags" variant="standard" />}
                                    />
                                </div>
                            </Grid>
                        <Grid item sm={12}>
                            <ButtonGroup variant="outlined" size="small">
                                <Button
                                    onClick={() => setListView('markerCreate')}
                                    startIcon={
                                        <Icon path={mdiDomainPlus}
                                            title="Add Marker"
                                            size={0.8}
                                            color="SlateBlue"
                                        />
                                    }
                                >
                                    Create Marker
                                </Button>
                                <Button
                                    onClick={() => setListView(listView === 'noList' ? 'markerList' : 'noList')}
                                    startIcon={
                                        listView === 'noList' ?
                                            <Icon path={mdiEye}
                                                title="Show List"
                                                size={0.8}
                                                color="DodgerBlue"
                                            />
                                            :
                                            <Icon path={mdiEyeOff}
                                                title="Hide List"
                                                size={0.8}
                                                color="Crimson"
                                            />
                                    }
                                >
                                    {listView === 'noList' ? 'Show' : 'Hide'} List
                                </Button>
                                {
                                    pinnedMarkers.length > 0 &&
                                    <Button
                                        onClick={() => dispatch(unpinAllMarkers())}
                                        endIcon={
                                            <Icon path={mdiPinOff}
                                                title="Unpin"
                                                size={0.8}
                                                color="Indigo"
                                            />
                                        }
                                    >
                                        Unpin All
                                    </Button>
                                }
                            </ButtonGroup>
                        </Grid>
                    </Fragment>
                }

            </Grid>
        )
    }

    return (
        <Paper>
            <div style={{ marginLeft: '15px', marginRight: '5px', marginBottom: '5px' }}>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Grid container spacing={1} justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6" style={{ display: 'inline' }}>
                                    <b>My Places</b>
                                </Typography>
                            </Grid>
                            <Grid item>
                                <ButtonGroup variant="text" size="small" color="primary">
                                    <Button onClick={() => setListView('zoneList')} variant={listView.search('zone') !== -1 ? 'contained' : 'text'}>Zones</Button>
                                    <Button onClick={() => setListView('markerList')} variant={listView.search('marker') !== -1 ? 'contained' : 'text'}>Markers</Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12}><Divider /></Grid>
                    {listView.search('zone') !== -1 && <Grid item sm={12}>{zoneView()}</Grid>}
                    {listView.search('marker') !== -1 && <Grid item sm={12}>{markerView()}</Grid>}
                    <Grid item sm={12}></Grid>
                </Grid>
            </div>
        </Paper>
    );
}

export default React.memo(PlacesTop);
